import { customInstance } from '@/features/auth/axios-config'
import {
  PaginatedResponseResponseThread,
  RequestFilters,
  RequestMarkThreadActionable,
  RequestUpdateComment,
  RequestUpdateThread,
  ResponseCreateComment,
  ResponseUpdateComment,
  SuccessResponseListResponseComment,
  SuccessResponseListResponseThread,
} from '@/schema'

const API_ENDPOINT_ANNOTATION = '/document/v1/comments'
const buildApiByCommentId = (id: string) => `${API_ENDPOINT_ANNOTATION}/${id}`

const API_ENDPOINT_THREAD = '/document/v1/threads'
const buildApiByThreadId = (threadId: string) =>
  `${API_ENDPOINT_THREAD}/${threadId}`
const buildApiByThreadIdAndActionable = (threadId: string) =>
  `${buildApiByThreadId(threadId)}/actionable`

export const annotationApi = {
  createComment: async (
    data: ResponseCreateComment
  ): Promise<ResponseCreateComment> => {
    return customInstance<ResponseCreateComment>({
      method: 'post',
      url: API_ENDPOINT_ANNOTATION,
      data,
    })
  },
  getThreadsList: async (
    data: Partial<RequestFilters>
  ): Promise<PaginatedResponseResponseThread> => {
    return customInstance<PaginatedResponseResponseThread>({
      method: 'post',
      url: `${API_ENDPOINT_THREAD}/list`,
      data,
    })
  },
  deleteComment: async (commentId: string): Promise<void> => {
    return customInstance<void>({
      method: 'delete',
      url: buildApiByCommentId(commentId),
    })
  },
  updateComment: async (
    commentId: string,
    data: RequestUpdateComment
  ): Promise<ResponseUpdateComment> => {
    return customInstance<ResponseUpdateComment>({
      method: 'put',
      url: buildApiByCommentId(commentId),
      data,
    })
  },
  deleteThread: async (threadId: string): Promise<void> => {
    return customInstance<void>({
      method: 'delete',
      url: buildApiByThreadId(threadId),
    })
  },
  updateThread: async (
    threadId: string,
    data: RequestUpdateThread
  ): Promise<SuccessResponseListResponseThread> => {
    return customInstance<SuccessResponseListResponseThread>({
      method: 'put',
      url: buildApiByThreadId(threadId),
      data,
    })
  },
  getCommentsList: async (
    data: Partial<RequestFilters>
  ): Promise<SuccessResponseListResponseComment> => {
    return customInstance<SuccessResponseListResponseComment>({
      method: 'post',
      url: `${API_ENDPOINT_ANNOTATION}/list`,
      data,
    })
  },
  markThreadActionable: async (
    threadId: string,
    data: RequestMarkThreadActionable
  ): Promise<SuccessResponseListResponseThread> => {
    return customInstance<SuccessResponseListResponseThread>({
      method: 'patch',
      url: buildApiByThreadIdAndActionable(threadId),
      data,
    })
  },

  /**
   * Check if a thread is synced
   * @param threadId - Thread ID to check
   * @returns Promise with synced status
   */
  checkThreadSync: async (
    threadId: string
  ): Promise<SuccessResponseListResponseThread> => {
    return customInstance<SuccessResponseListResponseThread>({
      method: 'get',
      url: `${buildApiByThreadId(threadId)}/sync`,
    })
  },

  /**
   * Mark a thread as read for the current user
   * @param threadId - Thread ID to mark as read
   * @returns Promise with updated thread read status
   */
  retryThreadSync: async (
    threadId: string
  ): Promise<SuccessResponseListResponseThread> => {
    return customInstance<SuccessResponseListResponseThread>({
      method: 'put',
      url: `${buildApiByThreadId(threadId)}/sync`,
    })
  },
}
